module.exports = __webpack_public_path__ + "media/images/slider_down-562d9e1e0e844e660e6a159957046421.png";